export const ERROR_FILE_SIZE = 'File size is too large, the file must be less than 5MB'
export const ERROR_COMMUNICATING_WITH_THE_SERVER = 'Error communicating with the server.. Please try again later!'
export const FILE_UPLOAD_SUCCESS = 'File uploaded successfully!'